export enum GoogleAdRoute {
  Roi = 'roi',
}
